import React from "react";
import { FormikFormGroup } from "components/common";
const ArchiveBackendNameDescriptionFormGroup = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  FormikFormGroup,
  {
    type: "text",
    name: "title",
    label: "Title",
    required: true,
    help: "Descriptive name of the backend.",
    labelClassName: "",
    wrapperClassName: ""
  }
), /* @__PURE__ */ React.createElement(
  FormikFormGroup,
  {
    type: "text",
    name: "description",
    label: "Description",
    required: true,
    help: "Backend description.",
    labelClassName: "",
    wrapperClassName: ""
  }
));
export default ArchiveBackendNameDescriptionFormGroup;
